import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import history from "../plugins/history";

interface State {
    open: boolean;
}

interface Props {
    projectId: number;
}

class AlertDevisModal extends React.Component <Props>{
    state: State = {
        open: true
    }

    close=()=>{
        this.setState({
            open: false
        })
        history.push({
            pathname: `/projects/${this.props.projectId}`,
            state: {projectId: `${this.props.projectId}`}
        });
    }
    render() {

        return (
            <Modal
                isOpen={this.state.open}
                toggle={this.close}
                modalClassName='alert-devis-modal'
                backdrop="static"
            >
                <ModalBody>
                    <h2>Demande complémentaire</h2>
                    <p>Nous vous enverrons un devis dans les plus brefs délais</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.close}>Envoyer</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AlertDevisModal;



// WEBPACK FOOTER //
// ./src/components/AlertDevisModal.tsx